import { render, staticRenderFns } from "./EmailsBox.vue?vue&type=template&id=c0954b00&scoped=true&"
import script from "./EmailsBox.vue?vue&type=script&lang=ts&"
export * from "./EmailsBox.vue?vue&type=script&lang=ts&"
import style0 from "./EmailsBox.vue?vue&type=style&index=0&id=c0954b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0954b00",
  null
  
)

export default component.exports